/** How block chrome (surface, padding, border) is presented */
export const BLOCK_PRESENTATION = Object.freeze({
  STANDALONE: 'standalone',
  EMBEDDED: 'embedded',
})
